import { TipoDocumentoAdmin } from "app/models/tipo-documento-admin.model";

export function setCookie(name: string, val: string) {
    const d = new Date();
    d.setTime(d.getTime() + 24 * 60 * 60 * 1000);
    document.cookie = `${name}=${val}; expires=${d.toUTCString()}; path=/; SameSite=None; Secure`;
}

export function getCookie(name: string): any {
    const nameLenPlus = (name.length + 1);
    return document.cookie
        .split(';')
        .map(c => c.trim())
        .filter(cookie => {
            return cookie.substring(0, nameLenPlus) === `${name}=`;
        })
        .map(cookie => {
            return JSON.parse(cookie.substring(nameLenPlus));
        })[0] || null;
}

export function deleteCookie(name: string) {
    const c = getCookie(name);

    if(!c)
        return;

    document.cookie = `${name}=;Max-Age=-99999999;path=/`;
}

export function setCookieLocal(tipoDocumentos: Array<TipoDocumentoAdmin>) {
    sessionStorage.setItem( 'LOCAL', JSON.stringify(tipoDocumentos));
}

export function verifyCookieLocal(): any {
    return JSON.parse(sessionStorage.getItem('LOCAL'));
}

export function deleteCookieLocal() {
    return sessionStorage.removeItem( 'LOCAL');
}